import clsx from "clsx";
import { ChevronLeftIcon, ChevronRightIcon } from "@radix-ui/react-icons";
import { useMemo } from "react";
import { Link } from "@remix-run/react";

interface TopicsPaginationProps {
  baseUrl: string;
  per: number;
  totalCount: number;
  page: number;
}

export function TopicsPagination({ baseUrl, per, totalCount, page }: TopicsPaginationProps) {
  const pages = useMemo(() => {
    return Math.ceil(totalCount / per);
  }, [totalCount, per]);

  const pagesArray = useMemo(() => {
    const arr: number[] = [];
    if (page === 1) {
      for (let i = 0; i < pages; i += 1) {
        const n = i + 1;
        if (n <= page + 4) {
          arr.push(n);
        }
      }
    } else if (page >= pages - 1) {
      for (let i = 0; i < pages; i += 1) {
        const n = i + 1;
        if (page - 2 <= n && n <= page + 2) {
          arr.push(n);
        }
      }
    } else {
      for (let i = 0; i < pages; i += 1) {
        const n = i + 1;
        if (page - 1 <= n && n <= page + 2) {
          arr.push(n);
        }
      }
    }
    return arr;
  }, [pages, page]);

  return (
    <div className={clsx("mx-auto", "max-w-xl", "pt-8", "flex", "justify-center")}>
      <div className={clsx("flex", "border", "border-blue-600", "rounded-full", "text-blue-600", "overflow-hidden")}>
        {page !== 1 && (
          <Link
            to={`${baseUrl}?page=${page - 1}`}
            aria-label="前へ"
            className={clsx(
              "block",
              "p-1",
              "border-r",
              "border-r-blue-600",
              "last:border-r-0",
              "last:px-2",
              "first:px-2"
            )}
          >
            <ChevronLeftIcon width="20" height="20" />
          </Link>
        )}
        {pagesArray.map((v) => {
          return (
            <Link
              key={v}
              to={`${baseUrl}?page=${v}`}
              aria-label={`ページ${v}`}
              className={clsx(
                "block",
                "p-1",
                "border-r",
                "border-r-blue-600",
                "last:border-r-0",
                "last:px-2",
                "first:px-2",
                page === v && ["bg-blue-50"]
              )}
            >
              <span className={clsx("flex", "items-center", "justify-center", "w-[20px]", "h-[20px]")}>{v}</span>
            </Link>
          );
        })}
        {page !== pages && (
          <Link
            to={`${baseUrl}?page=${page + 1}`}
            aria-label="次へ"
            className={clsx(
              "block",
              "p-1",
              "border-r",
              "border-r-blue-600",
              "last:border-r-0",
              "last:px-2",
              "first:px-2"
            )}
          >
            <ChevronRightIcon width="20" height="20" />
          </Link>
        )}
      </div>
    </div>
  );
}
